import axiosInstance from '../../../../config/axiosInstance';
const  CallTypeService = {
    async GetCallType(redirectCallback) {
        try {            
            const ClientID=localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Setup/GetCallType?ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    
};

export default CallTypeService;